import { createSelector } from 'reselect'
import { NetworkContentRootState } from '../networkContentRoot.reducer'

export const getTheme = createSelector(
  (state: NetworkContentRootState) => state.commonStore.theme,
  (state) => state,
)

export const getUser = createSelector(
  (state: NetworkContentRootState) => state.commonStore.user,
  (state) => state,
)

export const getGeneralOptions = createSelector(
  (state: NetworkContentRootState) => state.commonStore.generalOptions,
  (state) => state,
)

export const getLicensePermissions = createSelector(
  (state: NetworkContentRootState) => state.commonStore.licensePermissions,
  (state) => state,
)

export const namedRequestInProgress = createSelector(
  [
    (state: NetworkContentRootState) => state.commonStore.requests,
    (state: NetworkContentRootState, type: string) => type,
  ],
  (state, type) => {
    return state.filter(request => request.type === type && request.inProgress).length > 0
  },
)

export const namedRequestStatus = createSelector(
  [
    (state: NetworkContentRootState) => state.commonStore.requests,
    (state: NetworkContentRootState, type: string) => type,
  ],
  (state, type) => {
    return state.find(request => request.type === type)?.status
  },
)

export const namedRequestData = createSelector(
  [
    (state: NetworkContentRootState) => state.commonStore.requests,
    (state: NetworkContentRootState, type: string) => type,
  ],
  (state, type) => {
    return state.find(request => request.type === type)
  },
)
